<template>
  <nav class="navbar">
    <div>
      <router-link to="/" class="brand">{{ $t('navigationBar.siteTitle') }}</router-link>
    </div>
    <ul class="links">
      <li v-if="isLoggedIn"><a href="#" @click="doLogout">{{ $t('navigationBar.logout') }}</a></li>
      <li v-else><router-link to="/auth">{{ $t('navigationBar.login') }}</router-link></li>
    </ul>
  </nav>
</template>

<style lang="scss" scoped>
a {
  &, &:hover, &:active, &:visited {
    color: inherit;
    text-decoration: inherit;
  }
}

.navbar {
  height: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .brand {
    $h: 1.4em;

    width: $h * 3.54;
    height: $h;
    font-size: 1.3em;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-indent: 110%;
    background-image: url('../assets/logo.png');
  }

  .links {
    display: flex;
    align-items: center;
    list-style-type: none;

    margin-left: 10px;
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'

import Consts from '../lib/Consts'

export default {
  name: 'navigation-bar',
  computed: {
    ...mapGetters('session', ['isLoggedIn'])
  },
  methods: {
    ...mapActions('session', ['logout']),
    ...mapActions(['displayAlert']),
    doLogout () {
      this.logout()
      localStorage.setItem(Consts.LS_KEY_FLASH_MESSAGE, this.$t('app.loggedOut'))

      location.href = '/jewel_exchange/'
    }
  }
}
</script>
